import * as types from '../actions/actionTypes'
import * as auth from '../libs/auth'

export const VENDOR_LOGIN_PARAMS = ['app_name', 'hash_key', 'identifier']

const emptyUser = {
  member_id: 0,
  aifian_id: '',
  is_verified: 0,
  ci_verified: 0,
  reject_reason: '',
  has_id_card_num: false,
  email: '',
  bacon_level: -1,
  cream_hash: '',
  id_token: null,
  refresh_token: null,
  expires_in: 0,
  username: '',
}

export const initialState = auth.readUser() || emptyUser

// {
//   "member_id": 1,
//   "aifian_id": "aifian",
//   "is_verified": 1,
//   "ci_verified": 1,
//   "reject_reason": "",
//   "has_id_card_num": true,
//   "email": "xxx@abc.com",
//   "bacon_level": 5, // 目前小於 0 即不給使用 -> 登出
//   "cream_hash": "",
//   "id_token": "eyJraWQiOiJJaCthSmZ4S2lQRH…", // 供 API 身份驗證使用
//   "refresh_token": "eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0…", // 供持續登入驗證使用
//   "expires_in": 3600
// }

export function authenticatedSelector(user) {
  return !!user.id_token
}

export default function userReducer(user = initialState, action) {
  switch (action.type) {
    case types.LOGIN_SUCCESS:
    case types.REFRESH_TOKEN_SUCCESS: {
      const { payload } = action
      const newUser = { ...user, ...payload }
      auth.saveUser(newUser)
      return newUser
    }
    case types.LOGIN_ERROR:
    case types.REFRESH_TOKEN_ERROR:
    case types.LOGOUT_SUCCESS:
    case types.LOGOUT_ERROR:
      auth.onLogout()
      return emptyUser
    default:
      return user
  }
}
